// Home Fillgas portada do protótipo. Várias seções incluem este arquivo; a trava garante uma execução só.
// Roda no DOMContentLoaded porque o three.js (seção da caixa) carrega depois do hero.
(() => {
  if (window.__fgh) return;
  window.__fgh = true;
  document.addEventListener('DOMContentLoaded', () => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // troca de cor da máquina no card da loja: foto e link para a variante certa
  const cores = [...document.querySelectorAll('.fgh-pcard__cor')], foto = document.querySelector('.fgh-pcard__foto'), comprar = document.querySelector('.fgh-pcard__comprar');
  if (foto && comprar) cores.forEach(b => b.addEventListener('click', () => {
    cores.forEach(o => o.setAttribute('aria-pressed', String(o === b)));
    foto.src = b.dataset.img; foto.alt = b.dataset.alt; foto.width = +b.dataset.w; foto.height = +b.dataset.h;
    const u = new URL(comprar.href, location.href); u.searchParams.set('variant', b.dataset.variant); comprar.href = u.pathname + u.search;
    comprar.setAttribute('aria-label', 'Comprar a máquina Fillgas ' + b.textContent.trim().toLowerCase());
  }));

  // borbulhas depois do vídeo: o último quadro não fica parado. Coordenadas normalizadas do quadro 1920x1080;
  // a garrafa ocupa ~43–50% da largura e ~36–62% da altura. Fora dela, as bolhas evitam a máquina.
  const criaBolhas = media => {
    const cv = document.createElement('canvas');
    cv.className = 'fgh-hero__bolhas'; cv.setAttribute('aria-hidden', 'true');
    const antes = media.querySelector('.fgh-hero__ctl');
    media.insertBefore(cv, antes || null);
    const ctx = cv.getContext('2d');
    const IW = 1920, IH = 1080, G = { x0: .438, x1: .492, y0: .37, y1: .615 }, MAQ = { x0: .38, x1: .62 };
    let W = 0, H = 0, m = { s: 1, ox: 0, oy: 0 }, ps = [], raf = 0, ativo = false, visivel = true, ult = 0;
    const medir = () => {
      const dpr = Math.min(devicePixelRatio || 1, 2);
      W = media.clientWidth; H = media.clientHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const s = Math.max(W / IW, H / IH); m = { s, ox: (W - IW * s) / 2, oy: (H - IH * s) / 2 };
    };
    const nova = (dentro, espalhar) => {
      if (dentro) return { d: 1, nx: G.x0 + Math.random() * (G.x1 - G.x0), ny: espalhar ? G.y0 + Math.random() * (G.y1 - G.y0) : G.y1, r: .7 + Math.random() * 1.4, v: .09 + Math.random() * .12, f: Math.random() * 6.3, a: .35 + Math.random() * .4 };
      let nx; do { nx = Math.random() } while (nx > MAQ.x0 && nx < MAQ.x1);
      return { d: 0, nx, ny: espalhar ? Math.random() : 1.04, r: 1.4 + Math.random() * 4.2, v: .03 + Math.random() * .06, f: Math.random() * 6.3, a: .22 + Math.random() * .3 };
    };
    const popular = () => {
      const fora = W < 700 ? 20 : 36;
      ps = [];
      for (let i = 0; i < 28; i++) ps.push(nova(true, true));
      for (let i = 0; i < fora; i++) ps.push(nova(false, true));
    };
    const quadro = t => {
      raf = 0;
      if (!ativo || !visivel) return;
      const dt = Math.min(.05, (t - (ult || t)) / 1000); ult = t;
      ctx.clearRect(0, 0, W, H);
      const esc = Math.max(.55, m.s);
      for (let i = 0; i < ps.length; i++) {
        const b = ps[i];
        b.ny -= b.v * dt;
        if ((b.d && b.ny < G.y0) || (!b.d && b.ny < -.04)) { ps[i] = nova(b.d, false); continue; }
        const osc = Math.sin(t / 600 + b.f) * (b.d ? .0012 : .004);
        const x = m.ox + (b.nx + osc) * IW * m.s, y = m.oy + b.ny * IH * m.s, r = b.r * esc;
        if (b.d) {
          // dentro da garrafa: pontinhos claros, a água segue gaseificando
          ctx.fillStyle = `rgba(235,246,255,${b.a})`;
          ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.fill();
        } else {
          ctx.lineWidth = Math.max(.7, r * .22);
          ctx.strokeStyle = `rgba(215,236,255,${b.a})`;
          ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.stroke();
          ctx.fillStyle = `rgba(255,255,255,${b.a * .9})`;
          ctx.beginPath(); ctx.arc(x - r * .35, y - r * .35, r * .28, 0, 6.2832); ctx.fill();
        }
      }
      raf = requestAnimationFrame(quadro);
    };
    const roda = () => { if (!raf && ativo && visivel) { ult = 0; raf = requestAnimationFrame(quadro) } };
    new IntersectionObserver(es => { visivel = es[0].isIntersecting && !document.hidden; roda() }).observe(media);
    document.addEventListener('visibilitychange', () => { visivel = !document.hidden; roda() });
    addEventListener('resize', () => { medir(); if (ativo) popular() });
    medir();
    return {
      liga() { if (ativo) return; ativo = true; medir(); popular(); cv.classList.add('fgh-is-on'); roda() },
      desliga() { ativo = false; cv.classList.remove('fgh-is-on'); }
    };
  };

  // vídeo do hero: toca uma vez e para no último quadro
  const hv = document.querySelector('.fgh-hero__media video'), ctl = document.querySelector('.fgh-hero__ctl');
  const heroMedia = document.querySelector('.fgh-hero__media');
  const bolhas = heroMedia && !reduce ? criaBolhas(heroMedia) : null;
  if (hv && ctl && hv.querySelector('source')) {
    const ico = ctl.querySelector('.fgh-ico'), txt = ctl.querySelector('span');
    const PAUSE = 'M11 9h2v10h-2zM15 9h2v10h-2z', PLAY = 'M11.5 8.5v11l9-5.5z';
    const set = (label, d) => { txt.textContent = label; ico.setAttribute('d', d) };
    const play = () => { hv.classList.remove('fgh-is-off'); hv.play().catch(() => {}) };
    ctl.hidden = false;
    if (reduce) { hv.removeAttribute('autoplay'); hv.pause(); hv.classList.add('fgh-is-off'); set('Ver o vídeo', PLAY) }
    hv.addEventListener('play', () => { set('Pausar', PAUSE); if (bolhas) bolhas.desliga() });
    hv.addEventListener('pause', () => { if (!hv.ended) set('Continuar', PLAY) });
    hv.addEventListener('ended', () => { set('Ver de novo', PLAY); if (bolhas) bolhas.liga() });
    ctl.addEventListener('click', () => {
      if (hv.ended || hv.classList.contains('fgh-is-off')) { hv.currentTime = 0; play() }
      else if (hv.paused) play(); else hv.pause();
    });
  } else if (hv) {
    // sem vídeo cadastrado: fica só a foto, sem o botão de pausar
    hv.remove();
    if (ctl) ctl.remove();
    if (bolhas) bolhas.liga();
  } else if (bolhas) {
    bolhas.liga();
  }

  // caixa abrindo por cima: cena 3D com as medidas reais da caixa (mm) e fotos reais dos itens
  const ub = document.querySelector('.fgh-unbox');
  if (ub && window.THREE) {
    const T = THREE, cv = ub.querySelector('.fgh-scene__gl'), img = ub.dataset;
    const labels = [...ub.querySelectorAll('.fgh-scene__labels span')], lis = [...ub.querySelectorAll('.fgh-unbox__list li')];
    const sm = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t) };
    const W = 270, H = 450, D = 160, EL = .24;
    const rd = new T.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
    rd.setPixelRatio(Math.min(devicePixelRatio, 2)); rd.outputEncoding = T.sRGBEncoding;
    const sc = new T.Scene(), cam = new T.PerspectiveCamera(24, 1, 10, 20000);
    const ld = new T.TextureLoader(); ld.setCrossOrigin('anonymous'); let last = 0;
    const tx = u => { const t = ld.load(u, () => apply(last)); t.encoding = T.sRGBEncoding; t.anisotropy = 8; return t };
    const flat = (map, k) => new T.MeshBasicMaterial({ map, color: new T.Color(k, k, k) });
    const box = new T.Group(); sc.add(box);
    // cada parede: arte por fora, papelão por dentro
    const wall = (w, h, map, k, inner, pos, ry) => { const g = new T.PlaneGeometry(w, h); [new T.Mesh(g, flat(map, k)), new T.Mesh(g, new T.MeshBasicMaterial({ color: inner, side: T.BackSide }))].forEach(m => { m.position.set(...pos); m.rotation.y = ry; box.add(m) }) };
    wall(W, H, tx(img.front), 1, 0xC9D3DC, [0, H / 2, D / 2], 0);
    wall(W, H, tx(img.back), .8, 0xE2E9EF, [0, H / 2, -D / 2], Math.PI);
    wall(D, H, tx(img.side), .84, 0xB9C6D2, [W / 2, H / 2, 0], Math.PI / 2);
    wall(D, H, tx(img.side2), .72, 0xCCD7E1, [-W / 2, H / 2, 0], -Math.PI / 2);
    const bot = new T.Mesh(new T.PlaneGeometry(W, D), new T.MeshBasicMaterial({ color: 0xA7B7C6 })); bot.rotation.x = -Math.PI / 2; bot.position.y = 1; box.add(bot);
    const edges = new T.LineSegments(new T.EdgesGeometry(new T.BoxGeometry(W, H, D)), new T.LineBasicMaterial({ color: 0x6F95B5, transparent: true, opacity: .5 })); edges.position.y = H / 2; box.add(edges);
    // tampa presa na aresta de cima de trás; o entalhe fica na frente
    const hinge = new T.Group(); hinge.position.set(0, H, -D / 2); box.add(hinge);
    const topTex = tx(img.top); topTex.center.set(.5, .5); topTex.rotation = Math.PI;
    const lg = new T.PlaneGeometry(W, D);
    [new T.Mesh(lg, flat(topTex, 1.02)), new T.Mesh(lg, new T.MeshBasicMaterial({ color: 0xDCE4EB, side: T.BackSide }))].forEach(m => { m.rotation.x = -Math.PI / 2; m.position.set(0, .6, D / 2); hinge.add(m) });
    // sombras suaves no chão
    const shTex = (() => { const c = document.createElement('canvas'); c.width = c.height = 128; const g = c.getContext('2d'), gr = g.createRadialGradient(64, 64, 0, 64, 64, 64); gr.addColorStop(0, 'rgba(0,12,32,.6)'); gr.addColorStop(1, 'rgba(0,12,32,0)'); g.fillStyle = gr; g.fillRect(0, 0, 128, 128); return new T.CanvasTexture(c) })();
    const blob = (w, d) => { const m = new T.Mesh(new T.PlaneGeometry(w, d), new T.MeshBasicMaterial({ map: shTex, transparent: true, depthWrite: false })); m.rotation.x = -Math.PI / 2; m.position.y = .5; sc.add(m); return m };
    blob(W * 1.7, D * 2.6);
    // itens em escala real: saem retos pela abertura, atravessam por cima e pousam em fila
    const defs = [
      // f: fila no desktop; fm: arrumação compacta para tela estreita
      { u: img.maquina, h: 442, a: 465 / 900, s: [0, -10], f: [-305, 70], fm: [-250, 40], d: .28 },
      { u: img.cilindro, h: 360, a: 260 / 1400, s: [-70, 0], f: [190, 150], fm: [-20, 240], d: .44 },
      { u: img.garrafa, h: 280, a: 343 / 700, s: [60, 10], f: [300, 95], fm: [215, 150], d: .54 },
      { u: img.manual, h: 216, a: 349 / 520, s: [0, 20], f: [430, 30], fm: [330, 0], d: .64 }];
    const its = defs.map(o => { const w = o.h * o.a, g = new T.PlaneGeometry(w, o.h); g.translate(0, o.h / 2, 0);
      const m = new T.Mesh(g, new T.MeshBasicMaterial({ map: tx(o.u), transparent: true, alphaTest: .04, side: T.DoubleSide })); sc.add(m);
      const b = blob(w * 1.5, Math.max(w * .9, 70)); b.material.opacity = 0; return { o, m, b } });
    const v = new T.Vector3();
    const apply = e => {
      last = e;
      const w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
      rd.setSize(w, h, false); cam.aspect = w / h;
      hinge.rotation.x = -1.95 * sm(.04, .24, e);
      // enquadramento: começa perto da caixa, sobe junto com os itens no ar e abre para a fila final
      const air = sm(.24, .34, e) * (1 - sm(.8, .96, e)), spread = sm(.3, .62, e), az = .62 - .14 * e;
      const narrow = cam.aspect < .85;
      const needH = 720 - 40 * spread + 440 * air, needW = 560 + (narrow ? 200 : 500) * spread, ty = 225 + 60 * spread + 240 * air, cx = (narrow ? 40 : 85) * spread;
      const f = Math.tan(T.MathUtils.degToRad(cam.fov / 2)), dist = Math.max(needH / (2 * f), needW / (2 * f * cam.aspect));
      cam.position.set(cx + dist * Math.cos(EL) * Math.sin(az), ty + dist * Math.sin(EL), 30 + dist * Math.cos(EL) * Math.cos(az));
      cam.lookAt(cx, ty, 30); cam.updateProjectionMatrix();
      its.forEach(({ o, m, b }, i) => {
        const t = sm(o.d, o.d + .26, e), up = sm(0, .34, t), mv = sm(.3, .72, t), dn = sm(.66, 1, t), F = narrow ? o.fm : o.f;
        const x = o.s[0] + (F[0] - o.s[0]) * mv, z = o.s[1] + (F[1] - o.s[1]) * mv;
        m.visible = t > 0; m.position.set(x, (H + 25) * up * (1 - dn), z); m.rotation.y = az;
        b.position.set(x, .6, z); b.material.opacity = dn;
        const lb = labels[i];
        if (lb) { v.set(F[0], 0, F[1] + 30).project(cam); lb.style.transform = `translate(${((v.x + 1) / 2 * w).toFixed(1)}px,${((1 - v.y) / 2 * h + 8).toFixed(1)}px) translateX(-50%)`; lb.style.opacity = dn > .97 ? 1 : 0 }
        if (lis[i]) lis[i].style.setProperty('--on', dn > .97 ? 1 : 0);
      });
      rd.render(sc, cam);
    };
    const q = new URLSearchParams(location.search);
    if (q.has('e')) { apply(+q.get('e')); addEventListener('resize', () => apply(+q.get('e'))); window.__caixa = apply }
    else if (reduce) { ub.style.height = 'auto'; ub.querySelector('.fgh-unbox__sticky').style.position = 'relative'; apply(1); addEventListener('resize', () => apply(1)) }
    else {
      let tk = false;
      const up = () => { const r = ub.getBoundingClientRect(), p = Math.min(1, Math.max(0, -r.top / (r.height - innerHeight))); apply(p); tk = false };
      // no desktop o Horizon rola o .page-wrapper, não a janela; a captura no document pega os dois casos
      document.addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(up) } }, { passive: true, capture: true });
      addEventListener('resize', up); up();
    }
  } else if (ub) {
    // sem WebGL/three.js: a seção vira um bloco comum, com a lista visível
    ub.style.height = 'auto';
    ub.querySelector('.fgh-unbox__sticky').style.position = 'relative';
    ub.querySelectorAll('.fgh-unbox__list li').forEach(li => li.style.setProperty('--on', 1));
  }

  // parallax leve
  if (!reduce) {
    const els = [...document.querySelectorAll('.fgh [data-speed]')];
    let t = false;
    const run = () => { els.forEach(el => { const r = el.getBoundingClientRect(), c = r.top + r.height / 2 - innerHeight / 2; el.style.translate = `0 ${(c * +el.dataset.speed).toFixed(1)}px` }); t = false };
    if (els.length) { document.addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(run) } }, { passive: true, capture: true }); run() }
  }
  });
})();
